import { createContext } from 'react';

import { ImageType } from '@models/Image';

const _ContentViewModes = ['grid', 'list'] as const;
export type ContentViewMode = (typeof _ContentViewModes)[number];

export type GlobalViewModeValues = {
  contentViewMode: ContentViewMode;
  imageType: ImageType;
  setImageType: (imageType: ImageType) => void;
  toggleViewMode: () => void;
};

export const GlobalViewModeContext = createContext<GlobalViewModeValues>({
  contentViewMode: 'grid',
  imageType: 'poster',
  setImageType: () => void 0,
  toggleViewMode: () => void 0,
});

export default GlobalViewModeContext;

export const getOppositeViewMode = (currentViewMode: ContentViewMode): ContentViewMode =>
  currentViewMode === 'grid' ? 'list' : 'grid';
